import { render, staticRenderFns } from "./HowCanIGetPaidForBook.vue?vue&type=template&id=41c5e498&scoped=true"
import script from "./HowCanIGetPaidForBook.vue?vue&type=script&lang=js"
export * from "./HowCanIGetPaidForBook.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41c5e498",
  null
  
)

export default component.exports